import { createActorContext } from '@xstate/react';
import { signInMachine } from './sign-in';

/**
 * Determines whether the user came from our Direct Signup Page
 *
 * "Direct" signup is an alternative signup method that allows users to signup with minimal information.
 */
const clientIsFromDirectSignup = () => {
  return (
    new URLSearchParams(window.location.search).get('direct_signup') === 'true'
  );
};

const machineWithContext = signInMachine.withContext({
  isWafEnabled: false, // overriden in Login page
  isDirectSignupClient:
    typeof window !== 'undefined' && clientIsFromDirectSignup(),
});

export const SignInMachineContext = createActorContext(machineWithContext);
